// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__gQrc9","fade-in":"Tooltip_fade-in__bdBcr"};